import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';

@Pipe({
    name: 'localDate',
    standalone: false
})
export class LocaleDatePipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(localDate) {
    if(localDate != null && localDate.length == 3){
      let year = localDate[0];
      let month = localDate[1];
      let day = localDate[2];

    return year+"-"+month+"-"+day;

    }else{
      return "";
    }
  }

  reverseTransform(date:Date){
    let localDate = [];
    if(date != null){

      localDate[0] = date.getFullYear();
      localDate[1] = date.getMonth()+1;
      localDate[2] = date.getDay()+1;
    }

    return localDate;
  }
}
